import { ILaya } from "../../../ILaya";
import { EPhysicsStatisticsInfo } from "../physicsEnum/EPhysicsStatisticsInfo";
export class Physics3DStatInfo {
    static initStatisticsInfo() {
        for (let i = 0; i < EPhysicsStatisticsInfo.Count; i++) {
            this._PhysicsStatisticsInfo.set(i, 0);
        }
        if (Physics3DStatInfo.enableStatistics && Physics3DStatInfo.autoFrameClear) {
            ILaya.timer.frameLoop(1, null, Physics3DStatInfo.clearStatisticsInfo);
        }
    }
    static addStatisticsInfo(info, value) {
        Physics3DStatInfo.enableStatistics && (Physics3DStatInfo._PhysicsStatisticsInfo.set(info, Physics3DStatInfo._PhysicsStatisticsInfo.get(info) + value));
    }
    static getStatisticsInfo(info) {
        let value = 0;
        if (Physics3DStatInfo.enableStatistics) {
            value = Physics3DStatInfo._PhysicsStatisticsInfo.get(info);
        }
        return value;
    }
    static clearStatisticsInfo() {
        if (Physics3DStatInfo.enableStatistics) {
            for (let i = 0; i < EPhysicsStatisticsInfo.FrameClearCount; i++) {
                Physics3DStatInfo._PhysicsStatisticsInfo.set(i, 0);
            }
        }
    }
    static stopAndClearAllStatisticsInfo() {
        for (let i = 0; i < EPhysicsStatisticsInfo.Count; i++) {
            this._PhysicsStatisticsInfo.set(i, 0);
        }
        if (Physics3DStatInfo.enableStatistics && Physics3DStatInfo.autoFrameClear) {
            ILaya.timer.clear(null, Physics3DStatInfo.clearStatisticsInfo);
        }
    }
}
Physics3DStatInfo._PhysicsStatisticsInfo = new Map();
Physics3DStatInfo.enableStatistics = false;
Physics3DStatInfo.autoFrameClear = false;
